var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 60.5,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9652 37.7534L48.3329 52.8572C46.4394 55.0527 45.3828 57.9721 45.3828 61.0085C45.3828 64.0448 46.4394 66.9642 48.3329 69.1598L61.9652 84.2635C62.8019 85.1903 63.9366 85.7109 65.1199 85.7109C66.3031 85.7109 67.4378 85.1903 68.2745 84.2635C69.1111 83.3368 69.5812 82.0798 69.5812 80.7692C69.5812 79.4585 69.1111 78.2016 68.2745 77.2748L54.6391 62.171C54.3604 61.8622 54.2039 61.4435 54.2039 61.0068C54.2039 60.5702 54.3604 60.1514 54.6391 59.8426L68.2745 44.7421C69.1111 43.8153 69.5812 42.5584 69.5812 41.2477C69.5812 39.9371 69.1111 38.6801 68.2745 37.7534C67.4378 36.8266 66.3031 36.306 65.1198 36.306C63.9366 36.306 62.8019 36.8266 61.9652 37.7534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftCollection);
export default __webpack_public_path__ + "static/media/chevron-left-collection.efcfb0777feaa2e73b80d42609124e07.svg";
export { ForwardRef as ReactComponent };